angular.module('aprima-core-ui').directive('apSsnField', ['apSsnFilterFilter', function (apSsnFilter) {
    'use strict';
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ctrl) {
            ctrl.$parsers.push(function (inputValue) {
                var transformedInput = apSsnFilter(inputValue);
                if (transformedInput !== inputValue) {
                    ctrl.$setViewValue(transformedInput);
                    ctrl.$render();
                }
                return transformedInput;
            });
        }};
}]);
